/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const deleteTimesheetEntryPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

export const deleteTimesheetEntryQueryParamsSchema = z
  .object({
    mockUser: z.coerce.number().int().optional(),
  })
  .optional();

/**
 * @description OK
 */
export const deleteTimesheetEntry200Schema = z.any();

export const deleteTimesheetEntryMutationResponseSchema = z.lazy(
  () => deleteTimesheetEntry200Schema,
);
